import styled from "styled-components"

export const FaqListWrapper = styled.div`
  padding-inline-start: 0;
  list-style: none;
  counter-reset: custom-counter;
  display: flex;
  flex-wrap: wrap;
`